import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout from "../components/Layout";
import { Users, Heart, ShieldAlert, Flag, Ban, FileText } from "lucide-react";

function HtmlP({ html, className }) {
  return <p className={className} dangerouslySetInnerHTML={{ __html: html }} />;
}
function HtmlLi({ html }) {
  return <li dangerouslySetInnerHTML={{ __html: html }} />;
}

export default function Husregler() {
  const { t } = useTranslation();
  const k = (key) => t(`husregler.${key}`);
  const Sec = ({ icon: Icon, num, bullets, paragraphs }) => (
    <section className="mb-14">
      <div className="flex items-center gap-3 mb-5">
        <Icon className="h-5 w-5 text-[var(--magenta)]" />
        <h2 className="font-fraunces italic text-2xl text-[var(--cream)]">{k(`s${num}_title`)}</h2>
      </div>
      {paragraphs.map((p, i) => (
        p === "BULLETS" ? (
          <ul key={`b${num}`} className="list-disc pl-5 text-[var(--cream-soft)] space-y-2 mb-3 leading-relaxed">
            {bullets.map((bn) => <HtmlLi key={bn} html={k(`s${num}_b${bn}`)} />)}
          </ul>
        ) : (
          <HtmlP key={`p${num}_${p}`} html={k(`s${num}_p${p}`)} className="text-[var(--cream-soft)] leading-relaxed mb-3" />
        )
      ))}
    </section>
  );

  return (
    <Layout withSidebar={false}>
      <div className="max-w-3xl mx-auto" data-testid="husregler-page">
        <header className="mb-12">
          <div className="font-meta text-[var(--magenta)] mb-3">{k("section_label")}</div>
          <h1 className="font-fraunces italic text-4xl sm:text-5xl text-[var(--cream)] leading-tight mb-4">
            {k("title")}
          </h1>
          <p className="text-[var(--cream-soft)] leading-relaxed">{k("intro")}</p>
          <div className="font-meta text-[var(--cream-faint)] mt-5">{k("last_updated")}</div>
        </header>

        <Sec icon={Heart}        num={1} bullets={[1,2,3,4]}     paragraphs={[1, "BULLETS", 2]} />
        <Sec icon={Users}        num={2} bullets={[]}            paragraphs={[1, 2, 3]} />
        <Sec icon={ShieldAlert}  num={3} bullets={[1,2,3,4]}     paragraphs={[1, "BULLETS", 2]} />
        <Sec icon={Ban}          num={4} bullets={[1,2,3,4,5,6,7,8,9,10,11]} paragraphs={[1, "BULLETS"]} />
        <Sec icon={Flag}         num={5} bullets={[]}            paragraphs={[1, 2, 3]} />
        <Sec icon={FileText}     num={6} bullets={[1,2,3,4,5]}   paragraphs={[1, "BULLETS", 2]} />

        <div className="border-t border-white/10 pt-10 mt-10">
          <p
            className="text-[var(--cream-soft)] text-sm leading-relaxed mb-4 [&_a]:text-[var(--magenta)] [&_a]:underline-offset-4 hover:[&_a]:underline"
            dangerouslySetInnerHTML={{ __html: k("footer_supp") }}
          />
          <div className="flex gap-3 flex-wrap">
            <Link to="/" className="btn-ghost">{k("to_home")}</Link>
            <Link to="/personvern" className="btn-ghost" data-testid="husregler-til-vilkar">{k("to_terms")}</Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
